import { ISearchInput } from "../interfaces";
import { GaSearchInput } from "./gaia/GaSearchInput";

export const SearchInput = (props: ISearchInput) => {
    const { id, value, placeholder = "", ariaLabel = "", onChange, onKeyDown, inputRef, autoComplete = "off", dataTestId, tabIndex, additionalClassNames = "" } = props;

    if (window.useGaiaDesign) {
        return <GaSearchInput {...props} />;
    }

    return (
        <div className={`search-group ${additionalClassNames}`}>
            {id && <label htmlFor={id} className="sr-only">{ariaLabel}</label>}
            <input
                id={id}
                className="form-control pr-16"
                type="search"
                placeholder={placeholder}
                value={value}
                aria-label={ariaLabel}
                onChange={(e) => onChange(e.target.value)}
                onKeyDown={onKeyDown}
                ref={inputRef}
                autoComplete={autoComplete}
                data-testid={dataTestId}
                tabIndex={tabIndex}
            />
            <span className="search-icon">Search Icon</span>
            <span className="clear-search">Clear</span>
      </div>
    );
};
